export default class Checklist {
  constructor() {
    this.name = "";
    this.genericId = "";
    this.userId = "";
  }
}
